module.exports = __webpack_public_path__ + "img/secure-on.ea858741.svg";